import {Component, OnInit, ChangeDetectionStrategy, Input} from '@angular/core';
import {Review} from "./model/review.model";

@Component({
  selector: 'leap-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.less', '../../styles/tab-content.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ReviewsComponent implements OnInit {

  @Input() reviews : Array<Review>;

  public reviewsWrapper : Array<ReviewWrapper>;
  public sortByRatingASC = true;
  public sortByReviewDateASC = true;
  public onlyReviews;

  constructor() {}

  public filterUserTypeOptions = [
    { label: 'Buyers', value: 'Buyers', checked: true },
    { label: 'Sellers', value: 'Sellers', checked: true },
    { label: 'Instructors', value: 'Instructors', checked: true }
  ];

  ngOnInit() {
    this.reviewsWrapper = this.reviews.map((review: Review) => {
      return {review, visible : true}
    });
  }

  public sortByReviewDate() {
    this.sortByReviewDateASC = !this.sortByReviewDateASC;
    this.reviewsWrapper = this.reviewsWrapper.slice().sort((a: ReviewWrapper, b: ReviewWrapper) => {
      let dateA = new Date(a.review.reviewedAt);
      let dateB = new Date(b.review.reviewedAt);

      if ( dateA > dateB ){
        return this.sortByReviewDateASC ? -1 : 1;
      }
      if ( dateA < dateB ){
        return this.sortByReviewDateASC ? 1 : -1;
      }
      return 0;
    });
  }

  public  sortByRating() {
    this.sortByRatingASC = !this.sortByRatingASC;
    this.reviewsWrapper = this.reviewsWrapper.slice().sort((a: ReviewWrapper, b: ReviewWrapper) => {
      if ( a.review.rating > b.review.rating ){
        return this.sortByRatingASC ? -1 : 1;
      }
      if ( a.review.rating < b.review.rating ){
        return this.sortByRatingASC ? 1 : -1;
      }
      return 0;
    });
  }

  public filterByUserType() {

    this.reviewsWrapper.map((wrapper : ReviewWrapper) => {
      let userType =
          (wrapper.review.user.account.buyer ? 'Buyers' :
              (wrapper.review.user.account.seller ? 'Sellers' :
                  (wrapper.review.user.account.instructor ? 'Instructors' : null)));

      const checkedVal = this.filterUserTypeOptions.filter((option: any) => {
        return option.value === userType;
      })[0];

      wrapper.visible = checkedVal === undefined || checkedVal.checked;
    });
  }
}

interface ReviewWrapper {
  review: Review,
  visible: boolean
}
